import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import settingsTemplate from '../../templates/settings/index.html'
import quickKeysTemplate from '../../templates/settings/edit-qk-layout.html'
import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - SETTINGS
 * =======================================
 *
 * @module webregister.routes.settings
 */
function SettingsRoutesConfig($stateProvider: StateProvider) {
  $stateProvider
    .state(STATES.SETTINGS, {
      url: ROUTES.SETTINGS,
      template: settingsTemplate,
      controller: 'SettingsCtrl',
      controllerAs: 'settingsCtrl',
    })

    .state(STATES.SETTINGS_QUICK_KEYS, {
      url: '/quickkeys',
      abstract: true,
    })

    .state(STATES.SETTINGS_QUICK_KEYS_EDIT, {
      url: '/:layoutId',
      params: {
        newLayout: false,
      },
      views: {
        '@webregister': {
          template: quickKeysTemplate,
          controller: 'EditQuickKeyLayoutCtrl',
          controllerAs: 'editQuickKeyLayoutCtrl',
        },
      },
    })
}

angular.module('webregister.routes').config(SettingsRoutesConfig)
